import { useState } from "react"
import { DetailPage, Row } from "../../components/crud/DetailPage"
import { FkLink, ListPage } from "../../components/crud/ListPage"
import { AsyncSelect, NumberInput, TextInput } from "../../components/forms/Inputs"
import { useOptions } from "../../hooks/useOptions"
import { useTranslations } from "../../layers/Localization"

function OffreDetailFields({ item, set, tab }) {
    const [search, setSearch] = useState('')
    const t = useTranslations()
    const sectionOptions = useOptions('offreSections', 'nomFr')
    const frequenceOptions = useOptions('offreFrequences', ['frequences', 'nomFr'])
    const tachesOptions = useOptions('offreTaches', 'nomFr')

    const searchTask = (value, item) => {
        setSearch(value)
        if (item) set('descriptionFr')(item.nomFr)
    }
    return <>
        <Row>
            <AsyncSelect label={t("Chercher tâche")} value={search} onChange={searchTask} options={tachesOptions} />
        </Row>
        <hr />
        <Row>
            <TextInput className="grow" label={t("Description FR")} value={item.descriptionFr} onChange={set('descriptionFr')} required />
            <TextInput className="grow" label={t("Description NL")} value={item.descriptionNl} onChange={set('descriptionNl')} />
            <TextInput className="grow" label={t("Description EN")} value={item.descriptionEn} onChange={set('descriptionEn')} />
        </Row>
        <hr />
        <Row>
            <AsyncSelect className="grow" label={t("Section")} value={item.sectionId} onChange={set('sectionId')} options={sectionOptions} />
            <AsyncSelect className="grow" label={t("Fréquence")} value={item.frequenceId} onChange={set('frequenceId')} options={frequenceOptions} />
            <NumberInput label={t("Ordre")} value={item.ordre} onChange={set('ordre')} />
        </Row>
        <Row>
            <NumberInput label={t("Temps")} value={item.temps} onChange={set('temps')} />
            <NumberInput label={t("Quantité")} value={item.qte} onChange={set('qte')} />
        </Row>
    </>
}

export function OffreDetailsList(props) {
    const t = useTranslations()
    return <ListPage model="offresDetail" title={t("Détail")} columns={{
        [t('Ordre')]: 'ordre',
        [t('Section')]: { sort: 'section', value: item => <FkLink>{item.section?.nomFr}</FkLink> },
        [t('Description FR')]: 'descriptionFr',
        [t('Fréquence')]: { sort: 'frequence', value: item => <FkLink>{item.frequence?.frequences}</FkLink> },
        [t('Quantité')]: 'qte',
        [t('Temps')]: 'temps',
    }} join={{
        section: 'nomFr',
        frequence: 'frequences'
    }} {...props} />
}

export function OffreDetailDetail(props) {
    const t = useTranslations()
    return <DetailPage model="offresDetail" title={t("Détail")} Fields={OffreDetailFields} {...props} />
}
